import Box from '@mui/material/Box';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { conf } from 'src/config';
import { changePageTitle } from '../../actions';
import { GetBaseUrl } from 'src/domains/global/selectors'
import { httpGet, httpPatch, httpPost, httpPut } from 'src/utils'
import { Response } from 'src/domains/global/types';
import Documentation from 'src/domains/openapi/Documentation';


const OpenAPI: React.FC = () => {
    const base: string = useSelector(GetBaseUrl)!;
    const [loading, setLoading] = React.useState(false);
    const [json, setJson] = React.useState<any | null>(null);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(changePageTitle('Open API'));
        const jsonUrl = `${base}/api/openapi.json`;

        let active = true;
        (async () => {
            setLoading(true);
            const response: Response<any> = await httpGet(jsonUrl);

            if (!active) {
                return;
            }

            setJson(response.body);
            setLoading(false);
        })();

        return () => {
            active = false;
        };
    }, []);

    const rtConf = conf.getUiConf().routes;

    return (<>
        <Box>
            {
                (json !== null) && <Documentation json={json} />
            }
        </Box>
        {/* <pre>
            {
                JSON.stringify(json, null, 4)
            }
        </pre> */}
    </>)
}

export default OpenAPI;
